<div
  role="status"
  class="w-full h-full items-center justify-center"
  *ngIf="isLoadingTimeline"
>
  <svg
    aria-hidden="true"
    class="w-10 h-10 2xl:w-12 2xl:h-12 text-gray-200 animate-spin dark:text-gray-600 fill-[#141F58] items-center justify-center mx-auto"
    viewBox="0 0 100 101"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
      fill="currentColor"
    />
    <path
      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
      fill="currentFill"
    />
  </svg>
</div>

<!-- PLACEHOLDER TIMELINE - When NO data exists -->
<div class="flex flex-col h-full justify-center relative" *ngIf="!hasForecastData && !hasActualData && !isLoadingTimeline && timelineEvolution.length">
  
  <!-- No data message -->
  <div class="absolute inset-0 flex items-center top-4 2xl:top-7 justify-center pointer-events-none h-full z-20">
    <p class="text-gray-400 font-medium text-[0.7rem] 2xl:text-[0.75rem] 3xl:text-[0.8rem] bg-sky-100 px-4 py-2 rounded-sm mb-5">Non ci sono dati da mostrare</p>
  </div>

  <!-- Timeline Container - PLACEHOLDER -->
  <div class="relative px-2 h-full bottom-3 2xl:bottom-0">
    <div class="overflow-x-hidden">
      <ol class="flex-row items-start justify-start pb-4 relative inline-flex min-w-full">
        <!-- Continuous horizontal timeline -->
        <div class="absolute left-0 right-0 top-[25px] 2xl:top-[32px] h-[2px] bg-gray-100 dark:bg-gray-500 z-0"></div>
        
        <li
          *ngFor="let pointInTime of timelineEvolution; let i = index; let isFirst = first"
          class="relative min-w-[140px] 2xl:min-w-[160px] flex-shrink-0 flex flex-col px-2 2xl:px-2.5 z-10"
        >
          <!-- DATE -->
          <div class="flex flex-col items-start mb-3 2xl:mb-4 w-full relative">
            <time
              class="text-[0.6rem] 2xl:text-[0.7rem] font-bold text-gray-200 dark:text-gray-200 whitespace-nowrap mb-1 bg-white dark:bg-gray-900 pr-1 relative z-20"
              [ngClass]="isFirst ? 'ml-[-8px] 2xl:ml-[-10px]' : 'ml-[-19px]'"
            >
              {{ pointInTime.datePoint }}
            </time>
            
            <!-- Small vertical connector -->
            <div class="w-[2px] h-1.5 2xl:h-3 bg-gray-100 relative z-20"></div>
          </div>
        </li>
      </ol>
    </div>
  </div>
</div>



<!-- SCROLLING BUTTONS -->
 <div 
class="absolute z-11 w-[97.5%] h-12 bg-transparent pointer-events-none top-[60px] xl:top-[64px] 2xl:top-[82px]">
<div 
*ngIf="!isLoadingTimeline"
class="w-full h-full flex flex-row justify-between items-center">
  <!-- PREV Button -->
  <button   
    [disabled]="currentIndex === 0"
    (click)="prev()"
    [class.opacity-0]="currentIndex === 0"
    [class.pointer-events-none]="currentIndex === 0"
    [class.pointer-events-auto]="currentIndex !== 0"
    class="relative right-1 top-0 2xl:top-[1px] transition-all duration-100 bg-white border-2 border-gray-200 hover:bg-slate-100 rounded-full p-1.5 cursor-pointer flex items-center justify-center">
    <svg 
      class="w-[10px] h-[10px] 2xl:w-[14px] 2xl:h-[14px] mr-[1px] 2xl:mr-0.5"
      width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.5 15L7.5 10L12.5 5" stroke="#9CA3AF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg> 
  </button>
  
  <!-- NEXT Button -->
<button 
    (click)="next()"
    [disabled]="currentIndex >= maxIndex"
    [class.opacity-0]="currentIndex >= maxIndex"
    [class.pointer-events-none]="currentIndex >= maxIndex"
    [class.pointer-events-auto]="currentIndex < maxIndex"
    class="relative left-1 top-0 2xl:top-[1px] transition-all duration-100 bg-white border-2 border-gray-200 hover:bg-slate-100 rounded-full p-1.5 cursor-pointer flex items-center justify-center">
    <svg 
      class="w-[10px] h-[10px] 2xl:w-[14px] 2xl:h-[14px] ml-[1px] 2xl:ml-0.5"
      width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.5 5L12.5 10L7.5 15" stroke="#9CA3AF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button> 
</div>
</div>

<!-- REAL TIMELINE - When data exists -->

<div class="flex flex-col h-full justify-center" *ngIf="(hasForecastData || hasActualData) && !isLoadingTimeline && timelineEvolution.length">

  <!-- Timeline Container - WITH DATA -->
  <div class="relative px-2 h-full bottom-3 2xl:bottom-0">
    <div class="overflow-x-hidden scroll-smooth [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]" #carouselEvolutionRegionalAccess>
      <ol class="flex-row items-start justify-start pb-4 relative inline-flex min-w-full">
        <!-- Continuous horizontal timeline -->
        <div class="absolute left-0 right-0 top-[25px] 2xl:top-[32px] h-[2px] bg-gray-200 dark:bg-gray-500 z-0"></div>
        
        <li
          *ngFor="let pointInTime of timelineEvolution; let i = index; let isLast = last; let isFirst = first"
          class="relative w-[144px] xl:w-[148px] 2xl:w-[160px] flex-shrink-0 flex flex-col px-2 2xl:px-2.5 z-10 has-[.group:hover]:z-20 pointInTimelineMarket"
        >
          <!-- DATE -->
          <div class="flex flex-col items-start mb-3 2xl:mb-4 w-full relative">
            <div class="relative group z-30 flex items-center cursor-default gap-[0.2rem] mb-1 bg-white dark:bg-gray-900 pr-1" [ngClass]="(isFirst || i === currentIndex) ? 'ml-[-8px] 2xl:ml-[-10px]' : 'ml-[-19px]'">
              <time
                class="text-[0.6rem] 2xl:text-[0.7rem] font-bold text-gray-600 dark:text-gray-200 whitespace-nowrap relative z-20"
              >
                {{ pointInTime.datePoint }}
              </time>

              <span *ngIf="hasPeriodDates(pointInTime)" class="flex items-center justify-center p-[0.15rem]">
                <svg
                  class="w-[0.6rem] h-[0.6rem] 2xl:w-[0.75rem] 2xl:h-[0.75rem] text-gray-500 group-hover:text-[#141E58] transition-colors duration-150 pointer-events-none"
                  viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M7 14C7 13.4477 7.44772 13 8 13C8.55229 13 9 13.4477 9 14C9 14.5523 8.55229 15 8 15C7.44772 15 7 14.5523 7 14Z" fill="currentColor"></path>
                  <path d="M8 17C7.44772 17 7 17.4477 7 18C7 18.5523 7.44772 19 8 19C8.55229 19 9 18.5523 9 18C9 17.4477 8.55229 17 8 17Z" fill="currentColor"></path>
                  <path d="M11 14C11 13.4477 11.4477 13 12 13C12.5523 13 13 13.4477 13 14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14Z" fill="currentColor"></path>
                  <path d="M12 17C11.4477 17 11 17.4477 11 18C11 18.5523 11.4477 19 12 19C12.5523 19 13 18.5523 13 18C13 17.4477 12.5523 17 12 17Z" fill="currentColor"></path>
                  <path d="M15 14C15 13.4477 15.4477 13 16 13C16.5523 13 17 13.4477 17 14C17 14.5523 16.5523 15 16 15C15.4477 15 15 14.5523 15 14Z" fill="currentColor"></path>
                  <path d="M16 17C15.4477 17 15 17.4477 15 18C15 18.5523 15.4477 19 16 19C16.5523 19 17 18.5523 17 18C17 17.4477 16.5523 17 16 17Z" fill="currentColor"></path>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M6 2C6 1.44772 6.44772 1 7 1C7.55228 1 8 1.44772 8 2V3H16V2C16 1.44772 16.4477 1 17 1C17.5523 1 18 1.44772 18 2V3H19C20.6569 3 22 4.34315 22 6V20C22 21.6569 20.6569 23 19 23H5C3.34315 23 2 21.6569 2 20V6C2 4.34315 3.34315 3 5 3H6V2ZM16 5V6C16 6.55228 16.4477 7 17 7C17.5523 7 18 6.55228 18 6V5H19C19.5523 5 20 5.44772 20 6V9H4V6C4 5.44772 4.44772 5 5 5H6V6C6 6.55228 6.44772 7 7 7C7.55228 7 8 6.55228 8 6V5H16ZM4 11V20C4 20.5523 4.44772 21 5 21H19C19.5523 21 20 20.5523 20 20V11H4Z" fill="currentColor"></path>
                </svg>

              <!-- PERIOD TOOLTIP (forecast / actual intervals) -->
              <div
                class="absolute left-0 top-full mt-1 hidden group-hover:flex flex-col gap-[0.2rem] bg-white dark:bg-gray-800 border border-gray-200 rounded-md shadow-md px-[0.5rem] py-[0.35rem] whitespace-nowrap pointer-events-none"
              >
                <div *ngIf="pointInTime.forecastStartPeriodDate || pointInTime.forecastEndPeriodDate" class="flex items-center gap-[0.3rem] text-[0.5rem] 2xl:text-[0.6rem] text-gray-600 dark:text-gray-300">
                  <span class="w-[0.4rem] h-[0.4rem] rounded-full bg-[#00CEBC]"></span>
                  {{ formatPeriodDate(pointInTime.forecastStartPeriodDate) }} - {{ formatPeriodDate(pointInTime.forecastEndPeriodDate) }}
                </div>
                <div *ngIf="pointInTime.actualStartPeriodDate || pointInTime.actualEndPeriodDate" class="flex items-center gap-[0.3rem] text-[0.5rem] 2xl:text-[0.6rem] text-gray-600 dark:text-gray-300">
                  <span class="w-[0.4rem] h-[0.4rem] rounded-full bg-[#141E58]"></span>
                  {{ formatPeriodDate(pointInTime.actualStartPeriodDate) }} - {{ formatPeriodDate(pointInTime.actualEndPeriodDate) }}
                </div>
              </div>
              </span>
            </div>

           <!-- Small vertical connector -->
          <div class="w-[2px] h-1.5 2xl:h-3 bg-gray-200 relative z-20"></div>
          </div>

          <!-- FORECAST -->
          <div *ngIf="hasForecastData" class="flex flex-col items-center mb-3 2xl:mb-4 h-[68px] 2xl:h-[105px]">
            <div *ngIf="pointInTime.forecast && pointInTime.forecast[0]?.regions?.length" class="w-full h-full">
              <div class="bg-[#00cebd08] dark:bg-gray-800 rounded-lg p-2 relative right-1 2xl:p-2.5 border border-gray-200 transition-all h-full flex flex-col">
                <div class="flex-1 overflow-y-auto scrollbarForRegions space-y-0.5">
                  <p *ngFor="let region of pointInTime.forecast[0].regions"
                    (click)="handleRegionClick(pointInTime.datePoint, false, region)"
                    class="text-[0.5rem] 2xl:text-[0.7rem] text-dimot-secondary leading-relaxed cursor-pointer w-fit opacity-80 underline decoration-transparent underline-offset-[3px] hover:opacity-100 hover:decoration-current hover:translate-x-0.5 transition-all duration-200">
                    {{ region.name === "Prov. Aut. di Trento" ? "PA Trento" : region.name === "Prov. Aut. di Bolzano" ? "PA Bolzano" : region.name === "Friuli Venezia Giulia" ? "Friuli V. G." : region.name === "Emilia-Romagna" && timelineEvolution.length > 7 ? "Emilia R." : region.name === "Valle D'Aosta" && timelineEvolution.length > 7 ? "V. d'Aosta" : region.name }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <!-- ACTUAL -->
          <div *ngIf="hasActualData" class="flex flex-col items-center h-[68px] 2xl:h-[105px]">
            <div *ngIf="pointInTime.actual && pointInTime.actual[0]?.regions?.length" class="w-full h-full">
              <div class="bg-[#002aff08] dark:bg-gray-800 rounded-lg p-2 relative right-1 2xl:p-2.5 border border-gray-200 transition-all h-full flex flex-col">
                <div class="flex-1 overflow-y-auto scrollbarForRegions space-y-0.5">
                  <p *ngFor="let region of pointInTime.actual[0].regions"
                    (click)="handleRegionClick(pointInTime.datePoint, true, region)"
                    class="text-[0.5rem] 2xl:text-[0.7rem] text-dimot-1 dark:text-gray-300 leading-relaxed cursor-pointer w-fit opacity-80 underline decoration-transparent underline-offset-[3px] hover:opacity-100 hover:decoration-current hover:translate-x-0.5 transition-all duration-200">
                    {{ region.name === "Prov. Aut. di Trento" ? "PA Trento" : region.name === "Prov. Aut. di Bolzano" ? "PA Bolzano" : region.name === "Friuli Venezia Giulia" ? "Friuli V. G." : region.name === "Emilia-Romagna" && timelineEvolution.length > 7 ? "Emilia R." : region.name === "Valle D'Aosta" && timelineEvolution.length > 7 ? "V. d'Aosta" : region.name }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ol>
    </div>
  </div>
</div>

<app-modal-evolution-regional-market *ngIf="isModalOpen" [allInfo]="blockToSend" (isModalOpen)="handelModalOpen($event)"></app-modal-evolution-regional-market>